import { z } from 'zod';
export const haciendaEnvironment = z.enum(['staging', 'production']);
export const haciendaCredentialsInput = z.object({
    environment: haciendaEnvironment,
    username: z
        .string()
        .trim()
        .min(5, 'Usuario ATV inválido')
        .max(120)
        .regex(/@([a-z]+\.)?comprobanteselectronicos\.go\.cr$/i, 'El usuario termina en @comprobanteselectronicos.go.cr'),
    /** Vacío = conservar la contraseña guardada. */
    password: z.string().max(200).optional(),
});
export const certificateInput = z.object({
    /** Archivo .p12 en base64. */
    fileBase64: z.string().min(100, 'Archivo inválido').max(300_000, 'El archivo es demasiado grande'),
    pin: z.string().regex(/^\d{4}$/, 'El PIN tiene 4 dígitos'),
});
//# sourceMappingURL=hacienda-settings.js.map